// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('JVCustomization/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('JVCustomization/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    dispatch(getBank())
    const response = await axios.get('/InvoicePreviewCustomization/GetJVCustomization', { params })
    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data,
    }
})

export const getBank = createAsyncThunk('JVCustomization/getBank', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/Locations/GetBankDetails', { params })
    dispatch(setLoading({ getData: false }))

    return {
        params,
        data: response.data,
    }
})

export const JVCustomizationSlice = createSlice({
    name: 'JVCustomization',
    initialState: {
        data: {},
        bank_data: {},
        params: {},
        loadingState: { getData: false }
        // allData: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(getBank.fulfilled, (state, action) => {
                state.bank_data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default JVCustomizationSlice.reducer
